import * as Yup from 'yup';

export function macroMessageValidator() {
  return Yup.object().shape({
    customMacro: Yup
      .string()
      .required('Por favor, informe um conteúdo válido para prosseguir.'),
  });
}
